export const IMAGE_SOURCE = {
  male: {
    a: 'chris.jpg',
    b: 'christian.jpg',
    c: 'daniel.jpg',
    d: 'elliot.jpg',
    e: 'joe.jpg',
    f: 'justen.jpg',
    g: 'matt.jpg',
    h: 'steve.jpg',
    i: 'mark.png',
    j: 'matthew.png',
    k: 'patrick.png',
    l: 'chris.jpg',
    m: 'christian.jpg',
    n: 'daniel.jpg',
    o: 'elliot.jpg',
    p: 'joe.jpg',
    q: 'justen.jpg',
    r: 'matt.jpg',
    s: 'steve.jpg',
    t: 'mark.png',
    u: 'matthew.png',
    v: 'patrick.png',
    w: 'chris.jpg',
    x: 'christian.jpg',
    y: 'daniel.jpg',
    z: 'elliot.jpg',
  },
  female: {
    a: 'helen.jpg',
    b: 'jenny.jpg',
    c: 'laura.jpg',
    d: 'nan.jpg',
    e: 'stevie.jpg',
    f: 'veronika.jpg',
    g: 'elyse.png',
    h: 'kristy.png',
    i: 'lena.png',
    j: 'lindsay.png',
    k: 'molly.png',
    l: 'rachel.png',
    m: 'helen.jpg',
    n: 'jenny.jpg',
    o: 'laura.jpg',
    p: 'nan.jpg',
    q: 'stevie.jpg',
    r: 'veronika.jpg',
    s: 'elyse.png',
    t: 'kristy.png',
    u: 'lena.png',
    v: 'lindsay.png',
    w: 'molly.png',
    x: 'rachel.png',
    y: 'helen.jpg',
    z: 'jenny.jpg',
  },
};
